import { Config } from '@vkid/sdk';
import config from './config';

Config.init({
  app: Number(config.REACT_APP_VK_APP_ID),
  redirectUrl: 'https://vm.lab.vistar.ru/authorizeByVK',
});
